import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountDetailsItemsOfInterestDocument = gql`
  query SalesPortalAccountDetailsItemsOfInterest(
    $supplierUUID: uuid!
    $restaurantUUID: uuid!
    $fromDate: String!
  ) {
    getObiItems(
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      filter_from: $fromDate
    ) {
      obi_items {
        variant_pack_uuid
        title
        subtitle {
          en
          es
          fr
          zh
        }
        obi_item_type
        event_time
        variant_pack {
          uuid
          item {
            photo_url_list
            uuid
          }
        }
      }
    }
  }
`;
export function useSalesPortalAccountDetailsItemsOfInterestQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >(SalesPortalAccountDetailsItemsOfInterestDocument, options);
}
export function useSalesPortalAccountDetailsItemsOfInterestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >(SalesPortalAccountDetailsItemsOfInterestDocument, options);
}
export type SalesPortalAccountDetailsItemsOfInterestQueryHookResult =
  ReturnType<typeof useSalesPortalAccountDetailsItemsOfInterestQuery>;
export type SalesPortalAccountDetailsItemsOfInterestLazyQueryHookResult =
  ReturnType<typeof useSalesPortalAccountDetailsItemsOfInterestLazyQuery>;
export type SalesPortalAccountDetailsItemsOfInterestQueryResult =
  Apollo.QueryResult<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >;

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailsItemsOfInterestQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountDetailsItemsOfInterestQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >(SalesPortalAccountDetailsItemsOfInterestDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailsItemsOfInterestLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountDetailsItemsOfInterestLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountDetailsItemsOfInterestQuery,
    Types.SalesPortalAccountDetailsItemsOfInterestQueryVariables
  >(SalesPortalAccountDetailsItemsOfInterestDocument, lazyOptions);
}
